export const formatNumber = (num: number, numDigits = 2) => {
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: numDigits,
  });
};
